// @ts-nocheck
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";

const isUnitNetPriceZero = (pricing: ProductPriceDto | undefined | null) => {
    return Boolean(pricing && getUnitNetPrice(pricing, 1).price === 0);
};

export default isUnitNetPriceZero;
